@if (checklist.hasOwnProperty("minimumCharacters")) {
    <div
        uiCard
        class="row">
        <ui-checkbox
            [selected]="checklist.minimumCharacters"
            label="At least {{ passwordRequirements.minimumCharacters }} characters"></ui-checkbox>
    </div>
}

@if (checklist.hasOwnProperty("hasNumber")) {
    <div
        uiCard
        class="row">
        <ui-checkbox
            [selected]="checklist.hasNumber"
            label="At least 1 number"></ui-checkbox>
    </div>
}

@if (passwordRequirements.requireSpecialCharacter && checklist.hasOwnProperty("hasSpecialCharacter")) {
    <div
        uiCard
        class="row">
        <ui-checkbox
            [selected]="checklist.hasSpecialCharacter"
            label="At least 1 special character"></ui-checkbox>
    </div>
}

@if (checklist.hasOwnProperty("hasLowerAndUppercase")) {
    <div
        uiCard
        class="row">
        <ui-checkbox
            [selected]="checklist.hasLowerAndUppercase"
            label="Lower and uppercase"></ui-checkbox>
    </div>
}

@if (checklist.hasOwnProperty("passwordsMatching")) {
    <div
        uiCard
        class="row">
        <ui-checkbox
            [selected]="checklist.passwordsMatching"
            label="Passwords match"></ui-checkbox>
    </div>
}
